import React, { useState } from "react";
import { Row } from "reactstrap";

const SummaryCard = ({ title, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="mb-4" style={{ borderRadius: "12px" }}>
      <div  style={{ borderRadius: "12px",backgroundColor:"#F5F6F8",scrollBehavior:"smooth" }}>
        {/* Only this header toggles open/close */}
        <div
          onClick={() => setOpen(!open)}
          className="p-3 d-flex justify-content-between align-items-center"
          style={{ cursor: "pointer" }}
        >
          <h5 className="mb-0 text-black">{title}</h5>
          <i className={`fas fa-chevron-${open ? "up" : "down"}`}></i>
        </div>

        {/* Content shows only when open */}
        {open && <Row className="p-2">{children}</Row>}
      </div>
    </div>
  );
};

export default SummaryCard;
